import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { useNotification } from '../../contexts/NotificationContext';
import { TextField, Typography, InputAdornment, IconButton, Paper, Divider } from '@mui/material';
import {
    Person,
    Key,
    Numbers,
    Email,
    ArrowBack,
    Visibility,
    VisibilityOff,
    Close,
    Phone
} from '@mui/icons-material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import OTPInput from './OTPComp';
import { send_otp, verify_otp, login_with_password, signup } from '../../services/loginServices';
import { useAuth } from '../../contexts/AuthContext';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { useNavigate } from 'react-router-dom';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    maxWidth: '90vw',
    bgcolor: 'background.paper',
    borderRadius: '16px',
    boxShadow: 24,
    p: 0,
    overflow: 'hidden'
};

const headerStyle = {
    background: '#FFFFFF',
    color: 'black',
    padding: '24px',
    textAlign: 'center'
};

const contentStyle = {
    padding: '32px',
    color: '#680000'
};

// ---------------------------------------- MODAL LEVELS ----------------------------------------------------------
const MainPage = ({ loginLevel, setLoginLevel }) => (
    <Box>
        <Box sx={headerStyle}>
            <Typography variant='h5' sx={{ fontWeight: '600', mb: 1 }}>Welcome Back</Typography>
            <Typography variant='body2' sx={{ opacity: 0.9 }}>Sign in to your account</Typography>
        </Box>
        <Box sx={contentStyle}>
            <Button
                fullWidth
                variant='contained'
                sx={{
                    marginBottom: 3,
                    py: 1.5,
                    borderRadius: 2,
                    background: '#680000',
                    '&:hover': {
                        borderColor: '#680000',
                        background: '#680000'
                    }
                }}
                onClick={() => setLoginLevel(2)}
            >
                <Key sx={{ marginRight: '12px' }} />
                Login with Password
            </Button>
            <Button
                fullWidth
                variant='outlined'
                sx={{
                    marginBottom: 2,
                    py: 1.5,
                    borderRadius: 2,
                    borderColor: '#680000',
                    color: '#680000',
                    '&:hover': {
                        borderColor: '#680000',
                        background: 'rgba(102, 126, 234, 0.04)'
                    }
                }}
                onClick={() => setLoginLevel(6)}
            >
                <Numbers sx={{ marginRight: '12px' }} />
                Login with OTP
            </Button>
            <Divider sx={{ my: 3 }}>or</Divider>
            <Button
                fullWidth
                variant='text'
                sx={{
                    py: 1.5,
                    borderRadius: 2,
                    color: '#680000',
                    fontWeight: '600',
                    textDecoration: 'underline',
                    textUnderlineOffset: '3px',
                }}
                onClick={() => setLoginLevel(5)}
            >
                Create New Account
            </Button>
        </Box>
    </Box>
);

const PasswordLogin = ({ passwordType, handlePasswordType, handleLoginWithPassword }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);

    return (
        <Box>
            <Box sx={headerStyle}>
                <Typography variant='h5' sx={{ fontWeight: '600', mb: 1 }}>Password Login</Typography>
                <Typography variant='body2' sx={{ opacity: 0.9 }}>Enter your credentials</Typography>
            </Box>
            <Box sx={contentStyle}>
                <TextField
                    fullWidth
                    name="value"
                    label="Email or Phone Number"
                    value={passwordType.value}
                    onChange={handlePasswordType}
                    required
                    size="medium"
                    InputProps={{
                        startAdornment: <Person sx={{ color: '#680000', mr: 1 }} />
                    }}
                    sx={{
                        mb: 3,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            '&.Mui-focused fieldset': {
                                borderColor: '#680000',
                            },

                        },
                        '& .MuiInputLabel-root': {
                            color: '#680000',
                        },

                    }}
                />

                <TextField
                    fullWidth
                    name="password"
                    label="Password"
                    type={passwordVisible ? "text" : "password"}
                    value={passwordType.password}
                    onChange={handlePasswordType}
                    required
                    size="medium"
                    InputProps={{
                        startAdornment: <Key sx={{ color: '#680000', mr: 1 }} />,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setPasswordVisible(!passwordVisible)}>
                                    {passwordVisible ? <VisibilityOff sx={{ color: '#680000' }} /> : <Visibility sx={{ color: '#680000' }} />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        mb: 4,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            '&.Mui-focused fieldset': {
                                borderColor: '#680000',
                            },

                        },
                        '& .MuiInputLabel-root': {
                            color: '#680000',
                        },
                    }}
                />

                <Button
                    fullWidth
                    variant='contained'
                    onClick={handleLoginWithPassword}
                    sx={{
                        py: 1.5,
                        borderRadius: 2,
                        background: '#680000',
                        fontSize: '1rem',
                        '&:hover': {
                            borderColor: '#680000',
                            background: '#680000'
                        }
                    }}
                >
                    Sign In
                </Button>
            </Box>
        </Box>
    );
};

const OTPLogin = ({ otpType, handlePhoneNumberChange, submitGetOTP, otpMethod,handleOTPEmailChange }) => {
    return (
        <Box>
            <Box sx={headerStyle}>
                <Typography variant='h5' sx={{ fontWeight: '600', mb: 1 }}>
                    OTP Login
                </Typography>
                <Typography variant='body2' sx={{ opacity: 0.9 }}>
                    We'll send a code to your {otpMethod.toLowerCase()}
                </Typography>
            </Box>
            <Box sx={contentStyle}>
                {/* <TextField
                    fullWidth
                    name={otpMethod === "Email" ? "email" : "phone"}
                    label={otpMethod === "Email" ? "Email Address" : "Phone Number"}
                    type={otpMethod === "Email" ? "email" : "tel"}
                    value={otpMethod === "Email" ? otpType.email : otpType.phone}
                    onChange={handlePhoneNumberChange}
                    required
                    size="medium"
                    inputProps={{
                        maxLength: otpMethod === "Phone" ? 15 : 50,
                        inputMode: otpMethod === "Phone" ? "numeric" : "text",
                        pattern: otpMethod === "Phone" ? "[0-9]*" : undefined
                    }}
                    InputProps={{
                        startAdornment: otpMethod === "Email" ?
                            <Email sx={{ color: '#680000', mr: 1 }} /> :
                            <Phone sx={{ color: '#680000', mr: 1 }} />
                    }}
                    sx={{
                        mb: 4,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            '&.Mui-focused fieldset': {
                                borderColor: '#680000',
                            },

                        },
                        '& .MuiInputLabel-root': {
                            color: '#680000',
                        },
                    }}
                /> */}

                {otpMethod === "Email" ? (
                    <TextField
                        fullWidth
                        name="email"
                        label="Email Address"
                        type="email"
                        value={otpType.email}
                        onChange={handleOTPEmailChange} // Create separate handler for email
                        required
                        size="medium"
                        inputProps={{
                            maxLength: 50,
                        }}
                        InputProps={{
                            startAdornment: <Email sx={{ color: '#680000', mr: 1 }} />
                        }}
                        sx={{
                            mb: 4,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                '&.Mui-focused fieldset': {
                                    borderColor: '#680000',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#680000',
                            },
                        }}
                    />
                ) : (
                    <PhoneInput
                        country="sg"
                        specialLabel=""
                        value={otpType.phone || ''}
                        onChange={(phone, country) => handlePhoneNumberChange(phone, { target: { value: phone, countryValue: country } })}
                        inputStyle={{
                            width: '100%',
                            height: '50.25px',
                            borderRadius: '6px',
                            color: 'black',
                            paddingLeft: '58px',
                            fontSize: '12px !important',
                        }}
                        buttonStyle={{
                            borderTopLeftRadius: '6px',
                            borderBottomLeftRadius: '6px',
                        }}
                        containerStyle={{
                            width: '100%',
                        }}
                    />
                )}

                <Button
                    fullWidth
                    variant='contained'
                    onClick={submitGetOTP}
                    sx={{
                        mt:2,
                        py: 1.5,
                        borderRadius: 2,
                        background: '#680000',
                        fontSize: '1rem',
                        '&:hover': {
                            borderColor: '#680000',
                            background: '#680000',
                        }
                    }}
                >
                    Send OTP
                </Button>
            </Box>
        </Box>
    );
};

const OTPSubmit = ({ submitOTP, otp, setOtp, submitGetOTP }) => {
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        if (counter === 0) return;

        const timer = setInterval(() => {
            setCounter(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [counter]);

    return (
        <Box>
            <Box sx={headerStyle}>
                <Typography variant='h5' sx={{ fontWeight: '600', mb: 1 }}>Verify OTP</Typography>
                <Typography variant='body2' sx={{ opacity: 0.9 }}>Enter the code we sent you</Typography>
            </Box>
            <Box sx={contentStyle}>
                <OTPInput length={6} otp={otp} setOtp={setOtp} />

                <Box sx={{ textAlign: 'center', mt: 3, mb: 2 }}>
                    {counter > 0 ? (
                        <Typography variant='body2' color='text.secondary'>
                            Resend OTP in 00:{counter < 10 ? `0${counter}` : counter}
                        </Typography>
                    ) : (
                        <Button
                            variant='text'
                            onClick={() => {
                                submitGetOTP();
                                setCounter(30);
                            }}
                            sx={{ color: '#680000', fontWeight: '600' }}
                        >
                            Resend OTP
                        </Button>
                    )}
                </Box>

                <Button
                    fullWidth
                    variant='contained'
                    onClick={submitOTP}
                    sx={{
                        py: 1.5,
                        borderRadius: 2,
                        background: '#680000',
                        fontSize: '1rem',
                        '&:hover': {
                            borderColor: '#680000',
                            background: '#680000'
                        }
                    }}
                >
                    Verify & Sign In
                </Button>
            </Box>
        </Box>
    );
};

const SignUp = ({ signUpData, setSignUpData, handleSignUpChange, submitSignupData, handleSignupPhoneNumberChange }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [cPasswordVisible, setCPasswordVisible] = useState(false);

    return (
        <Box>
            <Box sx={headerStyle}>
                <Typography variant='h5' sx={{ fontWeight: '600', mb: 1 }}>Create Account</Typography>
                <Typography variant='body2' sx={{ opacity: 0.9 }}>Join us today</Typography>
            </Box>
            <Box sx={contentStyle}>
                <TextField
                    fullWidth
                    name="username"
                    label="Full Name"
                    value={signUpData.username}
                    onChange={handleSignUpChange}
                    required
                    size="medium"
                    InputProps={{
                        startAdornment: <Person sx={{ color: '#680000', mr: 1 }} />
                    }}
                    sx={{
                        mb: 3,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '6px',
                            '&.Mui-focused fieldset': {
                                borderColor: '#680000',
                            },

                        },
                        '& .MuiInputLabel-root': {
                            color: '#680000',
                        },
                    }}
                />

                <TextField
                    fullWidth
                    name="password"
                    label="Password"
                    type={passwordVisible ? "text" : "password"}
                    value={signUpData.password}
                    onChange={handleSignUpChange}
                    required
                    size="medium"
                    InputProps={{
                        startAdornment: <Key sx={{ color: '#680000', mr: 1 }} />,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setPasswordVisible(!passwordVisible)}>
                                    {passwordVisible ? <VisibilityOff sx={{ color: '#680000' }} /> : <Visibility sx={{ color: '#680000' }} />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        mb: 3,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '6px',
                            '&.Mui-focused fieldset': {
                                borderColor: '#680000',
                            },

                        },
                        '& .MuiInputLabel-root': {
                            color: '#680000',
                        },
                    }}
                />

                <TextField
                    fullWidth
                    name="c_password"
                    label="Confirm Password"
                    type={cPasswordVisible ? "text" : "password"}
                    value={signUpData.c_password}
                    onChange={handleSignUpChange}
                    required
                    size="medium"
                    InputProps={{
                        startAdornment: <Key sx={{ color: '#680000', mr: 1 }} />,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setCPasswordVisible(!cPasswordVisible)}>
                                    {cPasswordVisible ? <VisibilityOff sx={{ color: '#680000' }} /> : <Visibility sx={{ color: '#680000' }} />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        mb: 3,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '6px',
                            '&.Mui-focused fieldset': {
                                borderColor: '#680000',
                            },

                        },
                        '& .MuiInputLabel-root': {
                            color: '#680000',
                        },
                    }}
                />
                {/* <Box sx={{ mb: 3 }}> */}
                    <PhoneInput
                        country="sg"
                        specialLabel=""
                        value={signUpData?.phone || ''}
                        onChange={(phone, country) => handleSignupPhoneNumberChange("phone", { target: { value: phone, countryValue: country } })}
                        inputStyle={{
                            width: '100%',
                            height: '40.25px',
                            borderRadius: '6px',
                            color: 'black',
                            paddingLeft: '58px',
                            fontSize: '12px !important',
                            
                        }}
                        buttonStyle={{
                            borderTopLeftRadius: '6px',
                            borderBottomLeftRadius: '6px',
                        }}
                        containerStyle={{
                            width: '100%',
                        }}
                    />
                {/* </Box> */}
                {/* 
                <TextField
                    fullWidth
                    name="phone"
                    label="Phone Number (Optional)"
                    value={signUpData.phone}
                    type='tel'
                    onChange={handleSignUpChange}
                    size="medium"
                    inputProps={{ maxLength: 15 }}
                    InputProps={{
                        startAdornment: <Phone sx={{ color: '#680000', mr: 1 }} />
                    }}
                    sx={{
                        mb: 3,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            '&.Mui-focused fieldset': {
                                borderColor: '#680000',
                            },

                        },
                        '& .MuiInputLabel-root': {
                            color: '#680000',
                        },
                    }}
                /> */}

                <TextField
                    fullWidth
                    name="email"
                    label="Email Address"
                    value={signUpData.email}
                    onChange={handleSignUpChange}
                    required
                    size="medium"
                    InputProps={{
                        startAdornment: <Email sx={{ color: '#680000', mr: 1 }} />
                    }}
                    sx={{
                        mt:3,
                        mb: 4,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '6px',
                            '&.Mui-focused fieldset': {
                                borderColor: '#680000',
                            },

                        },
                        '& .MuiInputLabel-root': {
                            color: '#680000',
                        },
                    }}
                />

                <Button
                    fullWidth
                    variant='contained'
                    onClick={submitSignupData}
                    sx={{
                        py: 1.5,
                        borderRadius: '6px',
                        background: '#680000',
                        fontSize: '1rem',
                        '&:hover': {
                            borderColor: '#680000',
                            background: '#680000'
                        }
                    }}
                >
                    Create Account
                </Button>
            </Box>
        </Box>
    );
};

const OTPMethod = ({ setLoginLevel, setOtpMethod }) => (
    <Box>
        <Box sx={headerStyle}>
            <Typography variant='h5' sx={{ fontWeight: '600', mb: 1 }}>OTP Method</Typography>
            <Typography variant='body2' sx={{ opacity: 0.9 }}>Choose how to receive your code</Typography>
        </Box>
        <Box sx={contentStyle}>
            <Button
                fullWidth
                variant='contained'
                sx={{
                    marginBottom: 3,
                    py: 1.5,
                    borderRadius: 2,
                    background: '#680000',
                    '&:hover': {
                        // borderColor: '#680000',
                        background: '#680000'
                    }

                }}
                onClick={() => {
                    setOtpMethod("Email");
                    setLoginLevel(3);
                }}
            >
                <Email sx={{ marginRight: '12px' }} />
                Send OTP via Email
            </Button>
            <Button
                fullWidth
                variant='outlined'
                sx={{
                    marginBottom: 2,
                    py: 1.5,
                    borderRadius: 2,
                    borderColor: '#680000',
                    color: '#680000',
                    '&:hover': {
                        borderColor: '#680000',
                        background: 'rgba(102, 126, 234, 0.04)'
                    }
                }}
                onClick={() => {
                    setOtpMethod("Phone");
                    setLoginLevel(3);
                }}
            >
                <Phone sx={{ marginRight: '12px' }} />
                Send OTP via SMS
            </Button>
        </Box>
    </Box>
);

// ========================================= MAIN MODAL COMPONENT ========================================
export default function LoginModal({ loginModalOpen, setLoginModalOpen }) {
    const navigate = useNavigate();
    const { showError, showSuccess } = useNotification();
    const [loginLevel, setLoginLevel] = useState(1);
    const { loginUser, setLoginUser } = useRestaurant();
    const [countryNoLength, setCountryNoLength] = useState(0)
    const [passwordType, setPasswordType] = useState({
        'value': "",
        'password': ""
    });

    const [otpType, setOtpType] = useState({
        'phone': "",
        "email": ""
    });

    const [signUpData, setSignUpData] = useState({
        "username": "",
        "password": "",
        "c_password": "",
        "email": "",
        "phone": ""
    });

    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [otpMethod, setOtpMethod] = useState("Email");

    const handlePasswordType = (e) => {
        const updateData = {
            ...passwordType,
            [e.target.name]: e.target.value
        };
        setPasswordType(updateData);
    };

    const handleLoginWithPassword = async (e) => {
        if (passwordType.value === "") {
            showError("Please Enter Email")
            return;
        }
        if (passwordType.password === "") {
            showError("Please Enter Password")
            return;
        }
        let response = "";
        try {
            response = await login_with_password(passwordType);
            localStorage.setItem('access_token', response.access_token);
            localStorage.setItem('refresh_token', response.refresh_token);
            sessionStorage.setItem('user', JSON.stringify(response.user));
            setLoginUser(response.user);
            showSuccess("User Logged in Successfully");
            setLoginModalOpen(false);
            setLoginLevel(1);
            if (window.location.pathname === "/guest-signup") {
                navigate('/checkout')
            }
        } catch (error) {
            showError(error.message);
        }
    };
    const handleOTPEmailChange = (e) => {
         const updateData = {
            ...otpType,
            ["email"]: e.target.value
        };
        setOtpType(updateData);
    }


    const handleSignupPhoneNumberChange = (field, e) => {
        // console.log(e)
        let phoneNumber_Length = e.target.countryValue.format.split('.').length - 1;
        setCountryNoLength(phoneNumber_Length)
        const updateData = {
            ...signUpData,
            phone: e.target.value
        };
        setSignUpData(updateData);
    }

    const handlePhoneNumberChange = (field,e) => {
        // console.log("Phone Number Value => ", e)
        let phoneNumber_Length = e.target.countryValue.format.split('.').length - 1;
        const updateData = {
            ...otpType,
            ["phone"]: e.target.value
        };
        setOtpType(updateData);
    };

    const submitGetOTP = async () => {
        if (otpMethod === "Email") {
            const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            const email_verify = regex.test(otpType.email.trim());

            if (otpType.email === "") {
                showError("Please Enter Valid Email");
                return;
            }
            if (otpType.email !== "" && !email_verify) {
                showError("Please Enter Valid Email");
                return;
            }

        }

        if (otpMethod === "Phone" && !/^\d+$/.test(otpType.phone)) {
            showError("Please Enter a Valid Phone Number");
            return;
        }

        let response;
        try {
            response = await send_otp(otpType);
            showSuccess(response.message);
            setLoginLevel(4);
        } catch (error) {
            // console.error("Error on OTP Getting => ", error);
            showError(error?.message);
        }
    };

    const submitOTP = async () => {
        let actualOTP = otp.join("");
        let data = {
            ...otpType,
            "otp": actualOTP.toString()
        };
        try {
            const response = await verify_otp(data);
            if (response.status === 0) {
                showError(response.message);
                setOtp(new Array(6).fill(""));
            } else {
                localStorage.setItem('access_token', response.access_token);
                localStorage.setItem('refresh_token', response.refresh_token);
                sessionStorage.setItem('user', JSON.stringify(response.user));
                setLoginUser(response.user);
                showSuccess("User Logged in Successfully");
                setLoginLevel(1);
                setLoginModalOpen(false);
                if (window.location.pathname === "/guest-signup") {
                    navigate('/checkout')
                }
            }
        } catch (error) {
            // console.error("error Occured = >", error);
            showError("Something Went Wrong");
        }
    };

    const handleSignUpChange = (e) => {

        const updateData = {
            ...signUpData,
            [e.target.name]: e.target.value
        };
        setSignUpData(updateData);
    };

    const submitSignupData = async () => {
        if (!signUpData.username) {
            showError("Please Enter Name");
            return;
        }
        if (signUpData.username.length > 25) {
            showError("Please Enter Name less than 25 Characters");
            return;
        }

        if (/^\d+$/.test(signUpData.username)) {
            showError("Name cannot contain only numbers");
            return;
        }

        if (!signUpData.password) {
            showError("Please Enter Password");
            return;
        }
        if (signUpData.password.length < 8) {
            showError("Please Enter Atleast 8 Character Password");
            return;
        }
        if (!signUpData.c_password) {
            showError("Please Confirm Password");
            return;
        }
        if (signUpData.password !== signUpData.c_password) {
            showError("Password Mismatched Please Check Passwords");
            return;
        }

        if (signUpData.phone !== "" && !/^\d+$/.test(signUpData.phone)) {
            showError("Phone number must contain only digits");
            return;
        }

        if (signUpData.phone !== "" && signUpData.phone.length !== countryNoLength) {
            showError("Enter a Valid Phone Number")
            return;
        }


        if (!signUpData.email) {
            showError("Please Enter Email");
            return;
        }
        const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        const email_verify = regex.test(signUpData.email.trim());

        if (signUpData.email !== "" && !email_verify) {
            showError("Please Enter Valid Email");
            return;
        }

        try {
            const response = await signup(signUpData);
            showSuccess("User Signup Process Successfully Completed");
            setLoginLevel(1);
            setLoginModalOpen(false);
            setSignUpData({
                "username": "",
                "password": "",
                "c_password": "",
                "email": "",
                "phone": ""
            });
        } catch (error) {
            // console.error("Error Occured on Sig/nup => ", error);
            showError(error.message);
        }
    };

    const renderModalContent = () => {
        switch (loginLevel) {
            case 1:
                return <MainPage loginLevel={loginLevel} setLoginLevel={setLoginLevel} />;
            case 2:
                return <PasswordLogin passwordType={passwordType} handlePasswordType={handlePasswordType} handleLoginWithPassword={handleLoginWithPassword} />;
            case 3:
                return <OTPLogin otpType={otpType} handlePhoneNumberChange={handlePhoneNumberChange} submitGetOTP={submitGetOTP} otpMethod={otpMethod}  handleOTPEmailChange={handleOTPEmailChange}/>;
            case 4:
                return <OTPSubmit submitOTP={submitOTP} otp={otp} setOtp={setOtp} submitGetOTP={submitGetOTP} />;
            case 5:
                return <SignUp signUpData={signUpData} setSignUpData={setSignUpData} handleSignUpChange={handleSignUpChange} submitSignupData={submitSignupData} handleSignupPhoneNumberChange={handleSignupPhoneNumberChange} setCountryNoLength={setCountryNoLength} />;
            case 6:
                return <OTPMethod setLoginLevel={setLoginLevel} setOtpMethod={setOtpMethod} />;
            default:
                return null;
        }
    };

    const handleClose = () => {
        setLoginLevel(1);
        setLoginModalOpen(false);
        setSignUpData({
            "username": "",
            "password": "",
            "c_password": "",
            "email": "",
            "phone": ""
        });
        setPasswordType({
            'value': "",
            'password': ""
        })
        setOtpType({
            'phone': "",
            "email": ""
        })
    };

    return (
        <Modal
            open={loginModalOpen}
            onClose={handleClose}
            aria-labelledby="login-modal"
            aria-describedby="login-and-signup-modal"
        >
            <Box sx={style}>
                <Box sx={{ position: 'absolute', top: 16, left: 16, right: 16, display: 'flex', justifyContent: 'space-between', zIndex: 1 }}>
                    {loginLevel > 1 && (
                        <IconButton
                            onClick={() => {
                                setPasswordType({
                                    'value': "",
                                    'password': ""
                                })
                                setOtpType({
                                    'phone': "",
                                    "email": ""
                                })
                                setLoginLevel(1)
                            }}
                            sx={{
                                background: 'rgba(255,255,255,0.2)',
                                // color:'#680000',
                                backdropFilter: 'blur(10px)',
                                '&:hover': { background: 'rgba(255,255,255,0.3)' }
                            }}
                        >
                            <ArrowBack sx={{ color: '#680000' }} />
                        </IconButton>
                    )}
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            background: 'rgba(255,255,255,0.2)',
                            backdropFilter: 'blur(10px)',
                            '&:hover': { background: 'rgba(255,255,255,0.3)' }
                        }}
                    >
                        <Close sx={{ color: '#680000' }} />
                    </IconButton>
                </Box>
                {renderModalContent()}
            </Box>
        </Modal>
    );
}